import Vue from 'vue';
import VueRouter from 'vue-router';
import 'crypto-js/lib-typedarrays';
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';
Vue.use(VueRouter);
Vue.use(Amplify);

//views and layouts
import SignIn from '../views/SignIn.vue';
import EmailConfirmedSignin from '../views/EmailConfirmedSignIn.vue';
import PageNotFound from '../views/PageNotFound.vue';
import LoginOrSignupLayout from '../layouts/LoginOrSignupLayout.vue';

const routes = [
	{
		path: '/dashboard',
		name: 'Dashboard',
		meta: {
			requiresAuth: true,
		},
		beforeEnter() {
			window.location = import.meta.env.VITE_APPURL;
		},
	},
	{
		path: '/',
		name: 'Login',
		component: SignIn,
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/signin',
		name: 'SignIn',
		component: SignIn,
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	// {
	// 	path: '/success/signin',
	// 	name: 'SuccessSignIn',
	// 	component: SignIn,
	// 	meta: {
	// 		layout: LoginOrSignupLayout,
	// 		requiresAuth: false,
	// 	},
	// },
	{
		path: '/email-confirmed-signin',
		name: 'EmailConfirmedSignin',
		component: EmailConfirmedSignin,
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/signup',
		name: 'SignUp',
		component: () => import('../views/Signup.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
		children: [
			{
				path: 'locum',
				name: 'SignInLocum',
				component: () => import('../components/user/UserSignupForm.vue'),
				meta: {
					layout: LoginOrSignupLayout,
					requiresAuth: false,
				},
			},
			{
				path: 'practice',
				name: 'SignInPractice',
				component: () => import('../components/user/UserSignupForm.vue'),
				meta: {
					layout: LoginOrSignupLayout,
					requiresAuth: false,
				},
			},
		],
	},
	{
		path: '/confirm-signup',
		name: 'ConfirmSignup',
		component: () => import('../views/ConfirmSignup.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/confirm-signup/:username',
		name: 'ConfirmSignupId',
		component: () => import('../views/ConfirmSignup.vue'),
		props: true,
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/signout',
		name: 'SignOut',
		component: () => import('../views/SignOut.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: true,
		},
	},
	{
		path: '/forgot-password',
		name: 'ForgotPassword',
		component: () => import('../views/ForgotPassword.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/reset-password',
		name: 'ResetPassword',
		component: () => import('../views/ResetPassword.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/resend-confirmation-code',
		name: 'resendConfirmationCode',
		component: () => import('../components/user/ResendConfirmationForm.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	// and finally the default route, when none of the above matches:
	{
		path: '*',
		name: 'PageNotFound',
		component: PageNotFound,
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
	},
	{
		path: '/company/invite/accept',
		name: 'CompanyAcceptInvite',
		component: () => import('../views/AcceptCompanyInvite.vue'),
		meta: {
			layout: LoginOrSignupLayout,
			requiresAuth: false,
		},
		children: [
			{
				path: 'sign-in',
				name: 'CompanyAcceptInviteSignIn',
				component: () => import('../components/invite/AcceptInviteSignIn.vue'),
				meta: {
					layout: LoginOrSignupLayout,
					requiresAuth: false,
				},
			},
			{
				path: 'sign-up',
				name: 'CompanyAcceptInviteSignUp',
				component: () => import('../components/invite/AcceptInviteSignUp.vue'),
				meta: {
					layout: LoginOrSignupLayout,
					requiresAuth: false,
				},
			},
		],
	},
];

const router = new VueRouter({
	mode: 'history',
	base: import.meta.env.BASE_URL,
	routes,
});

router.beforeResolve((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		Auth.currentAuthenticatedUser()
			.then(() => {
				next();
			})
			.catch(() => {
				next({
					path: '/',
				});
			});
	}
	next();
});

// router.beforeResolve((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     let user;
//     Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
//       if (data && data.signInUserSession) {
//         user = data;
//         this.user = user;
//       }
//       //next()
//       location.href = "http://auth.locumbase.local:8085/dashboard";
//     }).catch((e) => {
//       //unauthenticated
//       next({
//         path: '/'
//       });
//     });
//   }
//   next()
// })
export default router;
